<style lang="less" scoped>
.center {
  position: relative;
  .map {
    width: 846/19.2vw;
    height: 693/10.8vh;
    background: url('../../../../../assets/img/chaye/map.png');
    background-size: 100% 100%;
    .main {
      width: 800/19.2vw;
      margin: 0 auto;
      height: 95%;
      padding-top: 6.3vh;
    }
  }
  .nametop {
    position: absolute;
    z-index: 999;
    top: 1.5vw;
    left: 1.5vw;
    font-size: 2vh;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    line-height: 4.3vh;
    padding-top: 1.2vh;

    &:before {
      display: block;
      content: '';
      width: 1000/1920vw;
      height: 1.8vh;
      background: rgba(254, 230, 20, 1);
      float: left;
      margin-top: 1.2vh;
      margin-left: 3vh;
      margin-right: 1vh;
      background-size: 100% 100%;
    }
  }
}
</style>

<template>
  <div class="center">
    <div class="nametop">商品流向地图</div>
    <div class="map"><div class="main"></div></div>
    <v-bottom></v-bottom>
  </div>
</template>

<script>
import bottom from "./centerBottom";
import echarts from "echarts";
import "echarts-gl";
import axios from "axios";
import earth from "@/assets/img/chaye/base3.jpg";
// import earth from "@/assets/img/chaye/8.png";
//  星空背景
// import bathymetry from "@/assets/img/chaye/bathymetry_bw_composite_4k.jpg";
//  星空背景
// import starfield from "@/assets/img/chaye/starfield.jpg";

// import starfield from "@/assets/img/chaye/22.png";
export default {
  data() {
    return {
      datalist: [],
      dataFJ: [],
      dataYN: []
    };
  },
  components: {
    "v-bottom": bottom
  },
  methods: {
    init() {
      window.addEventListener(
        "resize",
        function () {
          this.myChart.resize();
        }.bind(this)
      );
    },
    getRandomData(base1, base2) {
      return {
        coords: [
          [base1, base2],
          [Math.random() * 135.2, Math.random() * 53.33]
        ],
        value: (Math.random() * 30).toFixed(2)
      };
    }
  },
  mounted() {
    for (let i = 0; i < 30; i++) {
      this.dataFJ.push(this.getRandomData(119.3, 26.08));
      this.dataYN.push(this.getRandomData(102.72, 25.05));
    }
    this.dataGX = [
      {
        coords: [
          [95.45587012885734, 33.63134659765145],
          [121.51585, 31.23045]
        ],
        value: "20"
      }
    ];
    this.dataHN = [
      {
        coords: [
          [95.45587012885734, 33.63134659765145],
          [121.51585, 31.23045]
        ],
        value: "20"
      }
    ];
    this.dataZJ = [
      {
        coords: [
          [95.45587012885734, 33.63134659765145],
          [121.51585, 31.23045]
        ],
        value: "20"
      }
    ];
    let canvas = document.createElement("canvas");
    let mapChart = echarts.init(canvas, null, {
      width: 4096,
      height: 2048
    });
    let pOp = {
      geo: {
        map: "china",
        label: {
          fontSize: 12
        },
        label: {
          normal: {
            show: false,
            textStyle: {
              color: "#fff",
              fontSize: 12
            }
          },
          emphasis: {
            textStyle: {
              color: "#fff",
              fontSize: 12
            }
          }
        },
        itemStyle: {
          normal: {
            areaColor: "transparent",
            borderColor: "#e6722c",
            borderWidth: 3
          },
          emphasis: {
            areaColor: "rgba(229,46,46,0.5)",
            borderColor: "#e6722c",
            // borderColor: "rgb(4,69,239)",
            borderWidth: 3
          }
        },
        regions: [
          {
            name: "南海诸岛",
            value: 0,
            itemStyle: {
              normal: {
                opacity: 0,
                label: {
                  show: false
                }
              }
            }
          }
        ],
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        boundingCoords: [
          [-180, 90],
          [180, -90]
        ]
      },
      data: []
    };
    mapChart.setOption(pOp);
    this.myChart = echarts.init(document.querySelector(".map .main"));
    var op = {
      backgroundColor: "transparent",
      visualMap: [
        {
          show: false,
          type: "continuous",
          seriesIndex: 0,
          text: ["scatter3D"],
          textStyle: {
            color: "#fff"
          },
          calculable: true,
          max: 3000,
          inRange: {
            color: ["#87aa66", "#eba438", "#d94d4c"],
            symbolSize: [8, 30]
          }
        }
      ],
      globe: {
        baseTexture: earth,
        // heightTexture: bathymetry,
        displacementScale: 0.04,
        shading: "lambert",
        // environment: starfield,
        light: {
          // 光照阴影
          main: {
            color: "#fff", // 光照颜色
            intensity: 1.2, // 光照强度
            shadow: true, // 是否显示阴影
            alpha: 40,
            beta: -30
          },
          ambient: {
            intensity: 1.2
          }
        },
        viewControl: {
          alpha: 30,
          beta: 160,
          // targetCoord: [116.46, 39.92],
          autoRotate: true,
          autoRotateAfterStill: 10,
          autoRotateDirection: 'ccw',
          distance: 150
          // projection: "perspective",
          // alpha: 90,
          // beta: 0,
          // center: [0, 50, 0], // 视角
          // targetCoord: [110.46, 10.92],
          // autoRotate: true,
          // autoRotateAfterStill: 10,
          // distance: 150 // 视距
        },
        postEffectL: {
          enable: true,
          depthOfFieldL: {
            enable: true,
            focalDistance: 1000,
            fstop: 100
          }
        },
        layers: [
          {
            type: "blend",
            texture: mapChart
          }
        ]
      },
      series: [
        {
          type: "scatter3D",
          coordinateSystem: "globe",
          label: {
            show: false
          },
          emphasis: {
            label: {
              show: false
            }
          },
          data: []
        },
        {
          name: "lines3D",
          type: "lines3D",
          coordinateSystem: "globe",
          effect: {
            show: true,
            period: 5,
            trailWidth: 3,
            trailLength: 0.5,
            trailOpacity: 1,
            trailColor: "#0087f4"
          },
          blendMode: "lighter",
          lineStyle: {
            width: 1,
            color: "#0087f4",
            opacity: 0
          },
          data: this.dataFJ,
          silent: false
        },
        {
          name: "lines3D",
          type: "lines3D",
          coordinateSystem: "globe",
          effect: {
            show: true,
            period: 5,
            trailWidth: 3,
            trailLength: 0.5,
            trailOpacity: 1,
            trailColor: "rgb(47,34,175)"
          },
          blendMode: "lighter",
          lineStyle: {
            width: 1,
            color: "rgb(47,34,175)",
            opacity: 0
          },
          data: this.dataYN,
          silent: false
        }
      ]
    };

    this.myChart.setOption(op);
    var self = this;
    self.init();
    // axios.get("../static/json/population.json").then(res => {
    //   // console.log(res.data)
    //   this.myData = res.data
    //     .filter(function(dataItem) {
    //       return dataItem[2] > 0;
    //     })
    //     .map(function(dataItem) {
    //       return [dataItem[0], dataItem[1], Math.sqrt(dataItem[2])];
    //     });
    //   console.log(this.myData);
    //   this.myChart = echarts.init(document.querySelector(".center .map"));
    //   var op = {
    //     visualMap: {
    //       show: false,
    //       min: 0,
    //       max: 60,
    //       inRange: {
    //         symbolSize: [1.0, 10.0]
    //       }
    //     },
    //     globe: {
    //       environment: starfield,

    //       heightTexture: bathymetry,

    //       displacementScale: 0.05,
    //       displacementQuality: "high",

    //       globeOuterRadius: 100,

    //       baseColor: "#000",

    //       shading: "realistic",
    //       realisticMaterial: {
    //         roughness: 0.2,
    //         metalness: 0
    //       },

    //       postEffect: {
    //         enable: true,
    //         depthOfField: {
    //           focalRange: 15,
    //           enable: true,
    //           focalDistance: 100
    //         }
    //       },
    //       temporalSuperSampling: {
    //         enable: true
    //       },
    //       light: {
    //         ambient: {
    //           intensity: 0
    //         },
    //         main: {
    //           intensity: 0.1,
    //           shadow: false
    //         },
    //         ambientCubemap: {
    //           texture: earth,
    //           exposure: 1,
    //           diffuseIntensity: 0.5,
    //           specularIntensity: 2
    //         }
    //       },
    //       viewControl: {
    //         autoRotate: false,
    //         beta: 180,
    //         alpha: 20,
    //         distance: 100
    //       }
    //     },
    //     series: {
    //       type: "scatter3D",
    //       coordinateSystem: "globe",
    //       blendMode: "lighter",
    //       symbolSize: 2,
    //       itemStyle: {
    //         color: "rgb(50, 50, 150)",
    //         opacity: 1
    //       },
    //       data: this.myData
    //     }
    //   };
    //   this.myChart.setOption(op);
    //   this.init();
    // });
  },
  beforeDestroy() { }
};
</script>



// WEBPACK FOOTER //
// index.vue?1cf9d1ba